import config from './config';
import moment from 'moment';
import { useState, useRef, useEffect, useCallback } from "react";
//import {getCookie} from './component/Config/cookie';
import axios from 'axios';
export const getAuthHeader = () => {
    const header = {
        headers: {
            //Authorization: "Bearer " + config.TOKEN,
            'Content-Type': 'application/json',
            //'Access_Token' : getCookie('acc_token')
        }
    };
    return header;
}

export const setError = (context, name, error, callback) => {
    context.setState({ [name]: { ...context.state[name], error } }, callback && callback);
}

export const onChange = (context, name, newValue, callback) => {
    context.setState({ [name]: { ...context.state[name], value: newValue } }, callback && callback);
}

export const setOptions = (context, name, value, callback) => {
    context.setState({ [name]: { ...context.state[name], options: value } }, callback && callback);
}

export const showLoader = (context) => {
    context.setState({ showLoader: true })
}

export const hideLoader = (context) => {
    context.setState({ showLoader: false })
}
export const ToSeoUrl = (url) => {
    if (url) {
        // make the url lowercase
        var encodedUrl = url.toString().toLowerCase();

        // replace & with and
        encodedUrl = encodedUrl.split(/\&+/).join("-and-");

        // remove invalid characters
        encodedUrl = encodedUrl.split(/[^a-z0-9]/).join("-");

        // remove duplicates
        encodedUrl = encodedUrl.split(/-+/).join("-");

        // trim leading & trailing characters
        encodedUrl = encodedUrl.trim("-");

        return encodedUrl;
    } else {
        return 'rozgar-jobs';
    }
};